module.exports = __webpack_public_path__ + "img/app_logo.1a0b13d0.png";